import BrandName from "./description/BrandName";
import Price from "./description/Price";
import Size from "./description/Size";
import Color from "./description/Color";
import Description from "./description/Description";
import ProductInformation from "./description/ProductInformations";
import { useEffect, useState } from "react";
import { getFees, getShippingExpenses } from "../../../network/api/ShippingFees.js";
import { useTranslation } from "react-i18next";

function ProductDescription({ product, personal, update_p }) {
  const [fees, setFees] = useState(0);
  const currentDate = new Date();
  const [shippingExpenses, setShippingExpenses] = useState(0);
    const { t } = useTranslation();

  useEffect(() => {
    getFees().then((response) => {
      setFees(response?.data?.shipping_duration);
    });
    const fetchShippingExpenses = async () => {
      const response = await getShippingExpenses();
      setShippingExpenses(response.data.amount); // Set shipping expenses from backend
    };
    fetchShippingExpenses()  }, []);

  // Calculate the delivery date by adding fees to the current date
  const deliveryDate = new Date(currentDate);
  deliveryDate.setDate(currentDate.getDate() + fees);

  // Helper function to get the month name
  const getMonthName = (monthIndex) => {
    const monthNames = [
      'يناير', 'فبراير', 'مارس', 'إبريل', 'مايو', 'يونيو',
      'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
    ];
    return monthNames[monthIndex];
  };

  // Format the delivery date as "day month"
  const formattedDeliveryDate = `${deliveryDate.getDate()} ${getMonthName(deliveryDate.getMonth())}`;

  return (
    <div className="product-description d-flex me-2 flex-grow-1 col-lg-6 ">
      <div className="container">
        <BrandName product={product} />
        <Price product={product?.product} />
        <div className="shipping-expenses">
          <p className="">{t('Shipping Fees')}</p>
          <p className=""> <span>{t('curency')}</span> {product?.product?.shipping_cost}</p>
        </div>
        {
          product?.product?.points >0 &&product?.product?.points&&
        <p> <span className="fs-5">Points:</span> {product?.product?.points}</p>

        }

        <p className="delivery-data">{t('Get it within')} {product?.product?.shipping_days} {t('day')}</p>
        <Size product={product?.product} personal={personal} update_p={update_p} />
        {/* <Color linked_products={product?.linked_products} id={product?.product?._id} /> */}
        <Description description={product?.product?.description} descriptionAr={product?.product?.description_ar} product={product} />
        <div className="d-lg-none">
          <ProductInformation desc={product?.product?.desc} />
        </div>
      </div>
    </div>
  );
}

export default ProductDescription;
